import React from 'react';
import { getUsersPaginated } from '../../api/userapi';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDateFields } from '../../helpers';
import SearchBar from '../SearchBar';
import { updateRedirect } from '../../helpers/redirect';
import '../css/View.css';

import DataTableBase from '../utils/DataTable';

class UserView extends React.Component {
    constructor(props) {
        super(props);
        let filterValue = '';

        this.table = React.createRef();
        this.state = {
            data: [],
            expanded: {},
            user: {},
            loading: true,
            onlyActive: false,
            customFilters: {
                showOnlyActiveFilter: true,
                onlyActiveFilterLabel: "Only show active users",
                onlyActiveOnChange: this.onlyActiveOnChange
            },
            value: filterValue,
            edit: false,
            searches: false,
            create: false,
            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }
        this.onlyActiveOnChange = this.onlyActiveOnChange.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }


    componentDidMount() {
        this.setState({
            loading: true
        })
        this.fetchData(this.state.value, 0, this.state.onlyActive)
    }

    handleEdit(user) {
        this.setState({
            edit: true,
            user: user
        })
    }

    onlyActiveOnChange = (e) => {
        let isChecked = e.target.checked;
        this.fetchData(this.state.value, 0, isChecked);
        this.setState({
            onlyActive: isChecked,
            page: 0,
            loading: true,
            value: this.state.value
        })
    }

    handleCreate() {
        this.setState({
            create: true
        })
    }
    filterSearch(event) {
        let value = event.target.value;
        if ((event.key === 'Enter' && value) || (!value)) {
            this.fetchData(value, 0, this.state.onlyActive);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page, this.state.onlyActive)
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page, this.state.onlyActive);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value, 0)
            this.isSorting = false;
        });
    }

    fetchData(filterValue, page, isChecked) {
        let p = <p className="cursor closed" >
            <FontAwesomeIcon icon="bars" size="sm" color="#28A745" />
        </p>;
        if (typeof filterValue === 'object')
            filterValue = this.state.value;
        if (page === undefined)
            page = this.state.page;
        if (page !== 0)
            page = page - 1;
        if (isChecked === undefined)
            isChecked = this.state.onlyActive;
        this.setState({ loading: true, error: false });
        getUsersPaginated(filterValue, page, this.state.perPage, this.state.orderBy, this.state.descending, isChecked)
            .then((res) => {
                let moreOptions = [];
                for (let x = 0; x < res.data.data.results.length; x++) {
                    moreOptions.push(p)
                }
                this.setState({
                    data: res.data.data.results,
                    pages: res.data.data.pageCount,
                    totalRows: res.data.data.rowCount,
                    moreOptions: moreOptions,
                    loading: false,
                })
            }).catch((err) => {
                let errorList = [];
                err.response.data.errors.map(function (e) { errorList.push(e.message) });

                this.setState({
                    data: [],
                    error: true,
                    loading: false,
                    onlyActive: false,
                    errorMessage: errorList
                })
            });
    }



    render() {

        if (this.state.edit) {
            return <Redirect
                to={{
                    pathname: `/secure/UserEdit/${this.state.user.userId}`,
                    state: { user: this.state.user }
                }}
            />;
        }

        if (this.state.create) {
            return <Redirect
                to={{
                    pathname: `/secure/userCreate`,
                }}
            />;
        }



        const columns = [
            {
                name:
                    <div
                        style={{
                            textIndent: 10,
                            textAlign: "left",
                            width: 170,
                        }}
                    >
                        Last name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '170px',
                selector: row => row.lastName,
                sortable: true,
                sortField: 'lastName',
                cell: row => <div onClick={() => this.handleEdit(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.lastName}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 170,
                        }}
                    >
                        First name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '170px',
                selector: row => row.firstName,
                sortable: true,
                sortField: 'firstName',
                cell: row => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.firstName}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 190,
                        }}
                    >
                        Club <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '190px',
                selector: row => row.clubName,
                sortable: true,
                sortField: 'clubName',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{row.clubName}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 150,
                        }}
                    >
                        Telephone <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '150px',
                selector: row => row.telephone,
                sortable: true,
                sortField: 'telephone',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{row.telephone}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 110,
                        }}
                    >
                        FTP Emails <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '110px',
                selector: row => row.ftpNotify,
                sortable: true,
                sortField: 'ftpNotify',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{row.ftpNotify ? "Yes" : "No"}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 100,
                        }}
                    >
                        Start date <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '100px',
                selector: row => row.startDate,
                sortable: true,
                sortField: 'startDate',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{!row.startDate ? "" : formatDateFields(row.startDate)}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 100,
                        }}
                    >
                        End date <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '100px',
                selector: row => row.endDate,
                sortable: true,
                sortField: 'endDate',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{!row.endDate ? "" : formatDateFields(row.endDate)}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 100,
                        }}
                    >
                        Role <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '100px',
                selector: row => row.role,
                sortable: true,
                sortField: 'role',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{row.role}</p></div>
            },
        ]

        return (
            <div >
                <SearchBar
                    onKeyUp={this.filterSearch}
                    onClick={this.filterSearch}
                    onChange={this.filterSearch}
                    value={this.state.value}
                    customFilters={this.state.customFilters}
                />
                <DataTableBase
                    columns={columns}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.perPage}
                    paginationDefaultPage={this.state.defaultPage}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    onSort={this.handleSort}
                />
                <button onClick={() => this.handleCreate()} className="btn mt-4"> + USER</button>
            </div>
        );
    }
}

export default connect(
    state => {
        return {
            users: state.data.users
        }
    },
    dispatch => ({
        currentNavigationConnect: (response) => { dispatch(updateRedirect(response)) }
    }))
    (UserView);
